export const apiRequest = async (url, method, payload = null, token = null) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      method,
      headers,
      body: payload ? JSON.stringify(payload) : null,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

// Use HTTP for local development, HTTPS for production
const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
export const API_BASE_URL = baseUrl;

// Forms API
export const getForms = async () => {
  const universityId = localStorage.getItem("universityId");
  const token = localStorage.getItem("token");
  const url = universityId
    ? `${API_BASE_URL}/forms/${universityId}`
    : `${API_BASE_URL}/forms/`;
  return await apiRequest(url, "GET", null, token);
};
export const getMultiForms = async () => {
  const token = localStorage.getItem("token");
  const url =  `${API_BASE_URL}/form/`;
  return await apiRequest(url, "GET", null, token);
};
export const createForm = async (formData) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/forms`;
  return await apiRequest(url, "POST", formData, token);
};

export const updateFormFields = async (formId, updatedFields) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/forms/${formId}`;
  return await apiRequest(url, "PUT", updatedFields, token);
};

// Universities API
export const getUniversities = async () => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/universities`;
  return await apiRequest(url, "GET", null, token);
};
export const getUsers = async () => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/users`;
  return await apiRequest(url, "GET", null, token);
};
export const createUniversity = async (universityData) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/universities`;
  return await apiRequest(url, "POST", universityData, token);
};

// Users API
export const getUsersByUniversity = async (universityId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/universities/${universityId}/users`;
  return await apiRequest(url, "GET", null, token);
};

export const createUser = async (userData) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/users`;
  return await apiRequest(url, "POST", userData, token);
};

// Events API
export const getEventsByUniversity = async (universityId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/universities/${universityId}/events`;
  return await apiRequest(url, "GET", null, token);
};

export const createEvent = async (eventData) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/events`;
  return await apiRequest(url, "POST", eventData, token);
};

// Submissions API
export const getSubmissionsByEvent = async (eventId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/events/${eventId}/submissions`;
  return await apiRequest(url, "GET", null, token);
};

export const createSubmission = async (submissionData) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/submissions`;
  return await apiRequest(url, "POST", submissionData, token);
};

// CRM Sync API
export const getCRMSyncSettings = async (universityId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/crm-sync/settings/${universityId}`;
  return await apiRequest(url, "GET", null, token);
};

export const updateCRMSyncSettings = async (universityId, settings) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/crm-sync/settings/${universityId}`;
  return await apiRequest(url, "PUT", settings, token);
};

export const triggerManualSync = async (tourId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/crm-sync/trigger/${tourId}`;
  return await apiRequest(url, "POST", null, token);
};

export const getCRMSyncJobs = async (universityId) => {
  const token = localStorage.getItem("token");
  const url = `${API_BASE_URL}/crm-sync/jobs/${universityId}`;
  return await apiRequest(url, "GET", null, token);
};